<template>
	<inertia-head title="Events" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Events</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Transform your life with TRC Events! Get access to our revolutionary online events and discounted tickets to help you learn, grow and develop yourself in any way imaginable. From personal development, financial literacy and career advice to networking opportunities and educational resources—all of it is just a few clicks away. Start your journey today!
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content">
		<div class="block block-rounded">
			<div class="block-content block-content-full border-bottom border-5 border-warning">
				<div role="tablist">
					<button type="button" id="tab_zoom" @click="selected_tab='zoom'" class="btn btn-outline-warning rounded-0 ms-2 px-3 active" role="tab" data-bs-toggle="tab" data-bs-target="#btabs-animated-fade-zoom" aria-controls="btabs-animated-fade-zoom" aria-selected="true"><i class="fa fa-video me-1"></i>ZOOM LIVE</button>
					<button type="button" id="tab_events" @click="getPhysical" class="btn btn-outline-warning rounded-0 ms-2 px-3" role="tab" data-bs-toggle="tab" data-bs-target="#btabs-animated-fade-events" aria-controls="btabs-animated-fade-events"><i class="fa fa-book-open me-1"></i>EVENTS</button>
				</div>
			</div>
			<div class="tab-content">
				<div id="btabs-animated-fade-zoom" class="tab-pane fade active show" role="tabpanel" aria-labelledby="btabs-animated-fade-zoom">
					<div class="block">
						<div class="featured-videos-bg p-4 border-bottom border-primary border-2 shadow">
							<h1 class="text-white">Zoom Event</h1>
							<div v-if="zoomEvents.length>0"
								style="background-size: cover;background-position: center center;" :style="{'background-image': 'url('+selectedZoom.event_img_url+')'}"
							>
				              	<div class="block-content block-content-full border border-primary bg-black-50" style="height: 450px;">
				                  	<div class="pt-3 text-center">
					                    <p class="h1 text-white fw-bold mb-3 video-title text-center">
					                      	{{selectedZoom.title}}
					                    </p>
					                    <div class="h2 m-0 text-white"><sub>{{selectedZoom.date_display}}</sub></div>
					                    <div v-if="countdown_time_left<=86400">
						                    <div v-if="!countdown_done" class="text-white mb-0 mt-2 p-4 pb-0">
						                      	<p class="m-0 mb-3 h3">TIME LEFT</p>
						                      	<div id="countdown_display" class="fw-bold m-0 display-4 text-primary">
						                      		{{countdown_display}}
						                      	</div>
						                    </div>
						                    <p v-if="countdown_time_left<=1800" class="m-0 p-0" :class="{'mt-7':countdown_done,'mt-4':!countdown_done}">
						                    	<a :href="selectedZoom.event_link" target="_blank" class="btn btn-success btn-lg rounded-pill">
						                    		<span class="h2"><i class="fa fa-arrow-alt-circle-right me-1"></i>Join Zoom</span>
						                    	</a>
						                    </p>
					                    </div>
				                  	</div>
				                </div>
							</div>
							<div v-if="zoomEvents.length==0" class="block-content block-content-full">
								<h1 class="text-center text-white mt-4">No Zoom Event Found</h1>
							</div>
						</div>

						<div v-if="zoomEvents.length>1" class="mt-5 block-content block-content-full">
							<div class="table-responsive">
								<h3>Live Zoom Schedules</h3>
								<table class="table">
									<thead>
										<tr>
											<th>TIME</th>
											<th>TOPIC</th>
											<th>HOST</th>
										</tr>
									</thead>
									<tbody v-for="(zoom,z_index) in zoomEvents">
										<tr v-if="z_index>0">
											<td>{{zoom.date_display}}</td>
											<td>{{zoom.title}}</td>
											<td>{{zoom.speaker_name}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div id="btabs-animated-fade-events" class="tab-pane fade" role="tabpanel" aria-labelledby="btabs-animated-fade-events">
					<div class="border-bottom border-4 border-primary shadow">
						<div class="featured-videos-bg p-4">
							<h1 class="text-white">Featured Event</h1>
							<div class="row justify-content-center">
								<div v-for="(featured,f_index) in featuredEvent" class="col-sm-5 col-md-5 col-lg-5 col-xl-5">
									<a class="block shadow-none bg-image" href="javascript:void(0)" style="background-size: cover;" :style="{'background-image': 'url('+featured.event_img_url+')'}"
									>
						                <div class="block-content block-content-full bg-black-50 border border-primary">
						                  	<div class="pt-7">
							                    <p class="h4 text-white fw-bold mb-3 video-title">
							                      	{{featured.title}}
							                      	<div><span class="badge bg-warning fs-xs">{{featured.category.toUpperCase()}}</span></div>
							                    </p>
							                    <p class="text-white-75 fw-medium fs-xs mb-0">
							                      	<span>
							                        	<i class="far fa-calendar-alt opacity-75 me-1"></i> {{featured.date_display}}
							                      	</span>
							                    </p>
							                    <p class="m-0 mt-2 p-0 text-center">
							                    	<a :href="featured.event_link" target="_blank" class="btn btn-outline-primary"><i class="fa fa-arrow-alt-circle-right me-1"></i>Get Tickets</a>
							                    </p>
						                  	</div>
						                </div>
					              	</a>
								</div>
								<div v-if="featuredEvent.length==0">
									<h1 class="text-center text-white mt-4">No Featured Event Found</h1>
								</div>
							</div>
						</div>
					</div>
					
					<div class="block-content block-content-full mt-5">
						<div class="input-group mb-3 border-bottom pb-2">
							<span class="input-group-text">Category</span>
							<select v-model="selected_category" class="form-control">
								<option value="">ALL</option>
								<option value="seminars">Seminars</option>
								<option value="trc_coffee">TRC Coffee</option>
							</select>
						</div>
						<div v-if="events.data.length==0" class="mt-5">
							<h1 class="text-center text-danger">No Events Found</h1>
						</div>
						<div v-else class="mt-5">
							<div class="block" :class="{'block-mode-loading':searching_process==true}">
								<pagination :collections="events" />
								<div class="row">
									<div v-for="(event,e_index) in events.data" :class="{'col-md-12':events.data.length==1,'col-md-6':events.data.length==2,'col-md-4':events.data.length>=3}">
										<a class="block shadow-none border-start border-5 bg-image" href="javascript:void(0)"
											:class="['border-primary','border-success','border-warning','border-info','border-danger'][Math.floor(Math.random() * 5)]"
											style="background-size: cover;" :style="{'background-image': 'url('+event.event_img_url+')'}"
										>
							                <div class="p-4 bg-black-50">
							                  <div class="pt-7">
							                    <p class="h5 text-white fw-bold mb-3 video-title">
							                      {{event.title}}
							                      <div><span class="badge bg-warning fs-xs">{{event.category.toUpperCase()}}</span></div>
							                    </p>
							                    <p class="text-white-75 fw-medium fs-xs mb-0">
							                      <span>
							                        <i class="far fa-calendar-alt opacity-75 me-1"></i> {{event.date_display}}
							                      </span>
							                    </p>
							                    <p class="m-0 mt-2 p-0 text-center">
							                    	<a :href="event.event_link" target="_blank" class="btn btn-outline-primary"><i class="fa fa-arrow-alt-circle-right me-1"></i>Get Tickets</a>
							                    </p>
							                  </div>
							                </div>
						              	</a>
									</div>
								</div>
								<div class="mt-3">
									<pagination :collections="events" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());

	gtag('config', window.gtag_id);

	import { onMounted, watch, ref, reactive } from 'vue'
	import AuthLayout from '../../Layouts/AuthLayout'
	import { Inertia } from '@inertiajs/inertia'

	export default {
		layout: AuthLayout,
		props: {
			tab 			: String,
			category 		: String,
			zoomEvents 		: Object,
			featuredEvent 	: Object,
			events 			: Object,
		},
		created() {

			var _this = this;
			
			setTimeout(function(){ 
                var elem = "";

                if(_this.tab=='events')
                {
                	elem =  document.getElementById('tab_events');
                }else{
                	elem =  document.getElementById('tab_zoom');	
                }
                elem.click(); 
            }, 1);

	  	},
		setup(props) {

			onMounted(() => {
				const pageContainer = document.getElementById('page-container')
				if (pageContainer.classList.contains('sidebar-o-xs'))
					pageContainer.classList.remove('sidebar-o-xs')
			})

			const countdown_time_left 	= ref(90000);
			const selected_tab 			= ref(props.tab);

			const searching_process 	= ref(false);

			const selectedZoom 			= reactive({});
			
			Object.assign(selectedZoom,props.zoomEvents[0]);
				
			const selected_category 	= ref(props.category);

			const getPhysical = ()=>{
										selected_category.value = props.category;
										selected_tab.value 		= 'events';
									}

			//START For Zoom Event Countdown

			if(props.zoomEvents.length>0)
			{
				if(selectedZoom.time_left<=86400)
				{
					countdown_time_left.value = selectedZoom.time_left;
					setTimeout(function(){
					    countdown_time_left.value--;
					},1000);
				}
			}

			const countdown_done 	= ref(false);
			const countdown_display = ref('00:00:00');
			
			watch(countdown_time_left,(value,old_value)=>{

				var self = this;
				var hrs = 0, mins = 0, secs = 0;
				if (value>0 && value!=old_value) {

					hrs 	= Math.floor(countdown_time_left.value/60/60);
					mins 	= Math.floor(countdown_time_left.value/60);
					secs 	= value;

					secs 	= secs % 60;
					mins 	= mins % 60;
					hrs 	= hrs % 24;

					countdown_display.value = (hrs>9 ? hrs : "0" + hrs) + ":" + (mins>9 ? mins : "0" + mins) + ":" + (secs>9 ? secs : "0" + secs);

					setTimeout(function(){
					    countdown_time_left.value--;
					},1000);

				} else {
					countdown_display.value = "00:00:00";
					countdown_done.value = true;
				}

			})
			//END For Zoom Event Countdown

			watch(selected_category,(value,old_value)=>{

				if(old_value!=value)
				{
					searching_process.value = true;
					Inertia.get(route('member.events'),
					{
						tab 		: selected_tab.value,
						category 	: selected_category.value
					},
					{
						preserveState: true,
						preserveScroll: true,
						only:['featuredEvent,events'],
						onSuccess:()=>searching_process.value = false
					});
				}
			})

			watch(selected_tab,(value,old_value)=>{

				if(old_value!=value)
				{
					Inertia.get(route('member.events'),
					{
						tab 	: selected_tab.value
					},
					{
						preserveState: true,
						preserveScroll: true,
						only:['zoomEvents,featuredEvent,events'],
					});
				}
			})


			return{
				selectedZoom,
				countdown_time_left,
				countdown_display,
				countdown_done,
				searching_process,
				selected_tab,
				getPhysical,
				selected_category,
			}
		},
	}
</script>